import React from 'react'
import './css/finish.css'
import finish from './../assets/finish.png'

const Finish = () => {
  return (
    <div className="finish section">
        <div className="finish__img">
          <img src={finish} alt="" />
        </div>
        <div className="category__text">回答が完了しました!</div>
        <div className="category__subtext">何がもらえるかはお楽しみに...</div>
    </div>
  )
}

export default Finish